module.exports = __webpack_public_path__ + "img/s11Model2.9465e225.webp";